/**
 * Delivery selector functions
 */
import { createSelector } from 'reselect';

const deliveryReducer = (state) => state.get('deliveryReducer');

/**
 * Retrieves loading state from delivery reducer
 */
export const loadingSelector = createSelector(deliveryReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from delivery reducer
 */
export const errorSelector = createSelector(deliveryReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves blocks state from delivery reducer
 */
export const blocksSelector = createSelector(deliveryReducer, (state) =>
  state.get('blocks').toJS(),
);

/**
 * Retrieves deliveries state from delivery reducer
 */
export const deliveriesSelector = createSelector(deliveryReducer, (state) =>
  state.get('deliveries').toJS(),
);

/**
 * Retrieves deliverable purchase orders
 */
export const deliverablePurchaseOrdersSelector = createSelector(
  deliveryReducer,
  (state) => state.get('deliverablePurchaseOrders').toJS(),
);

/**
 * Retrieves delivery availabilities
 */
export const availabilitiesSelector = createSelector(deliveryReducer, (state) =>
  state.get('availabilities').toJS(),
);

export const locationsSelector = createSelector(deliveryReducer, (state) =>
  state.get('locations').toJS(),
);

/**
 * Retrieves count state from deliveries reducer
 */
export const countSelector = createSelector(deliveryReducer, (state) =>
  state.get('count'),
);
